import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const OverflowMenuBottom = ({ children, closeMenu, className, ...other }) => {
  const classNames = classnames('overflow-menu-bottom', className);
  return (
    <li className={classNames} {...other}>
      {children}
    </li>
  );
};

OverflowMenuBottom.propTypes = {
  children: PropTypes.node,
  /**
   * A callback to tell the parent menu component that the menu should be closed.
   */
  closeMenu: PropTypes.func,
  className: PropTypes.string,
};

export default OverflowMenuBottom;
